export enum NodeType {
    MODULE = <any>'MODULE',
    FILE = <any>'FILE',
    CONNECTION = <any>'CONNECTION'
}
